import { render } from "./MFITTBookingSeatSelectionMethod.vue?vue&type=template&id=7b3faa21&scoped=true"
import script from "./MFITTBookingSeatSelectionMethod.vue?vue&type=script&lang=js"
export * from "./MFITTBookingSeatSelectionMethod.vue?vue&type=script&lang=js"

import "./MFITTBookingSeatSelectionMethod.vue?vue&type=style&index=0&id=7b3faa21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b3faa21"

export default script